var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _rect, _circle, _rect2, _path23, _rect3, _circle2, _rect4, _path24, _rect5, _circle3, _rect6, _path25, _rect7, _circle4, _rect8, _path26, _path27, _path28, _path29;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRegisterModelSuccessfully = function SvgRegisterModelSuccessfully(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 228,
    height: 137,
    fill: "none",
    viewBox: "0 0 228 137"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F3FBFC",
    d: "M170.772 2.289H18.395C8.715 2.289.867 9.835.867 19.144v100.19c0 9.309 7.848 16.856 17.528 16.856h152.377c9.68 0 17.528-7.547 17.528-16.856V19.144c0-9.309-7.848-16.855-17.528-16.855"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#99E0E5",
    d: "M170.366 2.289H18.801C8.896 2.289.867 10.009.867 19.535v7.52H188.3v-7.52c0-9.526-8.029-17.246-17.934-17.246"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3FBFC",
    d: "M105.824 10.53H20.418c-2.565 0-4.65 2.006-4.65 4.473s2.085 4.472 4.65 4.472h85.406c2.565 0 4.65-2.006 4.65-4.472s-2.085-4.472-4.65-4.472M168.217 18.242a.52.52 0 0 1-.333-.12.463.463 0 0 1-.032-.673l5.255-5.535a.52.52 0 0 1 .699-.03c.198.18.219.472.031.672l-5.255 5.535a.5.5 0 0 1-.365.15"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3FBFC",
    d: "M173.472 18.242a.5.5 0 0 1-.365-.15l-5.255-5.536a.464.464 0 0 1 .032-.672.52.52 0 0 1 .698.03l5.255 5.535a.463.463 0 0 1-.031.672.5.5 0 0 1-.334.12M161.617 18.171h-5.443c-.938 0-1.699-.732-1.699-1.634v-3.069c0-.902.761-1.634 1.699-1.634h5.443c.938 0 1.7.732 1.7 1.634v3.069c0 .902-.762 1.634-1.7 1.634m-5.443-5.394c-.396 0-.719.31-.719.691v3.069c0 .38.323.692.719.692h5.443c.396 0 .719-.311.719-.692v-3.069c0-.38-.323-.691-.719-.691z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D2F53",
    d: "M206.624 8.545s-4.729-1.574-5.524 4.336c-.787 5.918 0 17.747 9.467 18.927s11.435-.787 16.566-8.28c-3.348-.2-6.504-2.56-10.053-8.872s-8.279-7.493-10.448-6.111z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6CDAE",
    d: "M211.516 27.769s-1.798-5.18-1.694-7.364 0-3.268 0-3.268h-4.087s.899 8.455 0 10.632c-.9 2.184 5.781 0 5.781 0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0F6F7",
    d: "m218.398 58.46-3.116-33.823s-5.227 2.2-10.23 0-7.902 13.017-7.902 13.017v20.814h21.248z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6CDAE",
    d: "M191.618 36.594s-13.667-5.035-15.394-4.666c-1.726.37-4.272 1.374-4.89.691-.618-.682.273-1.767 1.614-2.28 1.341-.514 3.124-.964 3.124-.964s-3.036-1.413-2.12-1.502 3.621 1.1 6.978 1.887 13.001 2.361 13.001 2.361zM200.749 124.645v8.319h-4.713l-2.393-8.319z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D2F53",
    d: "m200.62 129.703 1.173 4.73h-14.655c2.738-1.63 5.468-3.26 8.206-4.898l5.276.16z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6CDAE",
    d: "M209.036 124.645v8.319h4.706l2.401-8.319z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D2F53",
    d: "m209.156 129.704-1.173 4.73h14.655l-8.206-4.899z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6CEC1",
    d: "M218.544 48.294s8.375 8.809 4.714 33.766c-3.662 24.958-6.802 44.046-6.802 44.046h-8.375l-1.574-65.093-4.714 30.836v34.257h-7.853c-.739-.153-3.317-13.065-3.59-14.334a100.6 100.6 0 0 1-2.08-15.82c-.714-13.956 2.193-28.354 5.413-41.82.329-1.39.722-2.86 1.734-3.815 2.417-2.288 8.368-.538 11.411-.53 2.192 0 4.384-.056 6.561-.32.514-.065 5.026-1.31 5.155-1.181z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#F0B09B",
    d: "m204.282 75.564 2.393-7.524-.168-8.978z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D83",
    d: "M195.441 50.84c.538-1.044 1.092-1.76 1.647-2.016 5.235.49 15.963 1.22 21.464-.98 0 0-8.528 8.432-23.111 2.996"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6CDAE",
    d: "M179.798 6.184c.715.032-1.381-4.858-1.325-5.437.056-.578 1.108-1.164 1.735-.337.626.835 2.12 6.384 3.26 7.348.554.465 2.834 2.778 5.043 5.043-.233.192-.466.393-.699.586-.466.385-.923.779-1.397 1.156-.145.113-.281.225-.426.337-.064.049-.144.105-.257.193q-.286.216-.538.442c-2.433-3.461-4.946-7.083-5.123-7.524-.345-.876-3.573-1.88-3.373-2.482.193-.602 2.377.635 3.1.667z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#3ECEDD",
    d: "M186.198 8.183c-.811.265 8.833 10.753 9.467 11.837s1.43 1.919 2.369 2.842c1.197 1.18 3.782 1.116 5.38 1.357.201.032.426.073.546.233.121.145.121.345.121.538-.024 5.236-.675 10.455-1.518 15.619-.755 4.61-1.245 9.668-2.939 14.045-1.55 3.999-5.557 2.288-5.517-1.51.016-1.35.651-2.602 1.181-3.847 6.368-15.04-8.223-25.728-14.294-38.745 0 0 5.172-2.353 5.212-2.369z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#BF9686",
    d: "M209.847 19.032a3.648 3.648 0 0 1-3.854.434c-.113-1.318-.265-2.33-.265-2.33h4.087s.08.635.024 1.896z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6CDAE",
    d: "M207.871 19.618a3.638 3.638 0 1 0 0-7.276 3.638 3.638 0 0 0 0 7.276"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6CDAE",
    d: "M211.365 17.225a.546.546 0 1 0 0-1.091.546.546 0 0 0 0 1.091"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D2F53",
    d: "M207.846 10.552s.393 4.73 2.369 5.919c1.975 1.18 5.123 1.18 5.123 1.18l-3.156-7.099zM207.766 10.552s-.394 4.73-2.369 5.919c-1.976 1.18-5.124 1.18-5.124 1.18l3.156-7.099z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#3ECEDD",
    d: "m180.987 35.647 4.264-7.1 4.24 2.12c1.157.579 2.257 1.406 3.606 1.342.819-.04 1.614-.29 2.393-.554 5.043-1.67 10.174-3.38 14.888-5.846 1.397-.723 2.955-1.149 4.512-1.325 1.751-.2 3.678-.345 4.786 1.3.538.804.771 1.783.908 2.739.458 3.14.843 6.272 1.116 9.435.233 2.715.41 5.445.578 8.167.089 1.421.169 2.85.297 4.28.032.345.057.69-.024 1.028-.144.554-.578.988-1.004 1.365a25 25 0 0 1-3.099 2.345c-.699.442-1.381 1.084-2.16 1.365-.434.16-.94.169-1.325-.072-1.454-.924-1.349-4.16-1.534-5.63-.434-3.436-.763-6.881-.915-10.342-.025-.602-.346-7.508-.579-7.476-2.73.417-5.484 1.421-8.158 2.128-2.578.682-5.148 1.461-7.749 2.072-2.433.57-4.489.208-6.89-.113-2.722-.361-5.437-.81-8.151-1.212z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B9486",
    fillOpacity: 0.7,
    d: "M37.933 75.09a.95.95 0 0 1 .95-.949h4.113v12.537h-4.114a.95.95 0 0 1-.95-.95z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44.895,
    height: 12.347,
    x: 38.028,
    y: 74.236,
    stroke: "#1B9486",
    strokeOpacity: 0.7,
    strokeWidth: 0.19,
    rx: 0.855
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 83.018,
    cy: 80.41,
    r: 0.628,
    fill: "#8C95A8",
    stroke: "#fff",
    strokeWidth: 0.19
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 30.46,
    height: 2.256,
    x: 47.121,
    y: 79.782,
    fill: "#1B9486",
    fillOpacity: 0.4,
    rx: 1.128
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D83",
    d: "M102.787 45.759a.95.95 0 0 1 .95-.95h4.113v12.537h-4.113a.95.95 0 0 1-.95-.95z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 44.895,
    height: 12.347,
    x: 102.882,
    y: 44.904,
    stroke: "#FF9D83",
    strokeWidth: 0.19,
    rx: 0.855
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.547,
    cy: 51.078,
    r: 0.628,
    fill: "#8C95A8",
    stroke: "#fff",
    strokeWidth: 0.19
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 30.46,
    height: 2.256,
    x: 112.556,
    y: 50.45,
    fill: "#FF9D83",
    fillOpacity: 0.5,
    rx: 1.128
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D83",
    d: "M102.787 75.09a.95.95 0 0 1 .95-.949h4.113v12.537h-4.113a.95.95 0 0 1-.95-.95z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 44.895,
    height: 12.347,
    x: 102.882,
    y: 74.236,
    stroke: "#FF9D83",
    strokeWidth: 0.19,
    rx: 0.855
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.547,
    cy: 80.41,
    r: 0.628,
    fill: "#8C95A8",
    stroke: "#fff",
    strokeWidth: 0.19
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 30.46,
    height: 2.256,
    x: 112.556,
    y: 79.782,
    fill: "#FF9D83",
    fillOpacity: 0.5,
    rx: 1.128
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D83",
    d: "M102.787 105.551a.95.95 0 0 1 .95-.949h4.113v12.537h-4.113a.95.95 0 0 1-.95-.95z"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 44.895,
    height: 12.347,
    x: 102.882,
    y: 104.697,
    stroke: "#FF9D83",
    strokeWidth: 0.19,
    rx: 0.855
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.547,
    cy: 111.223,
    r: 0.628,
    fill: "#8C95A8",
    stroke: "#fff",
    strokeWidth: 0.19
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 30.46,
    height: 2.256,
    x: 112.556,
    y: 110.242,
    fill: "#FF9D83",
    fillOpacity: 0.5,
    rx: 1.128
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    stroke: "#8C95A8",
    strokeDasharray: "0.38 0.38",
    strokeWidth: 0.19,
    d: "M83.223 80.364h19.178"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    stroke: "#5F677E",
    strokeDasharray: "0.38 0.38",
    strokeWidth: 0.19,
    d: "M92.662 51.103h9.403"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    stroke: "#60667F",
    strokeDasharray: "0.38 0.38",
    strokeWidth: 0.19,
    d: "M92.662 111.276h9.403"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    stroke: "#8C95A8",
    strokeDasharray: "0.38 0.38",
    strokeWidth: 0.19,
    d: "M92.343 51.578v59.793"
  })));
};
export default SvgRegisterModelSuccessfully;